import { Configuration } from "./eclipse-react-sdk/services/configuration";

export default function HttpRequestConfiguration(header) {
    const httpRequestConfiguration = new Configuration();
    if(header){
        const headers = { Authorization: header };
        httpRequestConfiguration.baseOptions = { headers };
    }
    return httpRequestConfiguration;
}